import './Signup.css';
import logo from '../../assets/images/logo.svg';
import securityIcon from '../../assets/images/security.svg';
import codeIcon from '../../assets/images/code.svg';
import chartIcon from '../../assets/images/chart.svg';
import { useState } from 'react';
import { MdOutlineVisibility, MdOutlineVisibilityOff } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { axiosInstance } from '../../config/axiosConfig';
import { SIGNUP } from '../../config/endpoint';
import loaderService from '../../service/loaderService';
import { showError } from '../../service/toastService';

const schema = yup.object().shape({
    firstName: yup.string().required('First Name is required'),
    lastName: yup.string().required('Last Name is required'),
    email: yup.string().email('Must be a valid email').required('Email is required'),
    organization: yup.string().required('Company / Organization is required'),
    password: yup.string().required('Password is required'),
    terms: yup.boolean().oneOf([true], 'You must accept the Terms of Service and Privacy Policy'),
});

const Signup = () => {
    const [isShowPassword, setIsShowPassword] = useState(false);
    const navigate = useNavigate();

    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(schema),
    });

    const onSubmit = data => {
        const payload = data;

        delete payload.terms;

        loaderService.show();
        axiosInstance.post(SIGNUP, payload)
            .then((res) => {
                localStorage.setItem('userInfo', JSON.stringify(res.user || {}));
                navigate('/signup-success');
            })
            .catch((err) => {
                showError(err?.response?.data?.message);
            })
            .finally(() => {
                loaderService.hide();
            });
    };

    return (
        <div className='signup'>
            <div className='signup_bg_left'>
                <div className='py-32'>
                    <img src={logo} alt="logo" />
                </div>
                <div className='text_content'>
                    <h5 className='heading_bold'>Get Context <br /> Out of Content</h5>
                    <div className='signup-details'>
                        <div className='signup-detail'>
                            <div className='icon'><img src={securityIcon} alt="securityIcon" /></div><span>Enterprise-Grade Security</span>
                        </div>
                        <div className='signup-detail'>
                            <div className='icon'><img src={codeIcon} alt="codeIcon" /></div><span>Easy Integration</span>
                        </div>
                        <div className='signup-detail'>
                            <div className='icon'><img src={chartIcon} alt="chartIcon" /></div><span>Smart Reporting</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className='signup_bg_right'>
                <div className='heading'>Welcome to <br /> <b>brainyagent.ai</b></div>
                <p className='font-22'>Create your account to get started.</p>

                <form className='w-100 gap-16 d-flex flex-column' autoComplete='off' onSubmit={handleSubmit(onSubmit)}>

                    <div>
                        <div className='input-container'>
                            <label> First Name </label>
                            <input type='text' className='input' {...register('firstName')} autoComplete="new-password" />
                        </div>
                        <p className='error-message'>{errors.firstName?.message}</p>
                    </div>
                    <div>
                        <div className='input-container'>
                            <label> Last Name </label>
                            <input type='text' className='input' {...register('lastName')} autoComplete="new-password" />
                        </div>
                        <p className='error-message'>{errors.lastName?.message}</p>
                    </div>

                    <div>
                        <div className='input-container'>
                            <label> Work Email Address </label>
                            <input type="text" className='input' {...register('email')} autoComplete="new-password" />
                        </div>
                        <p className='error-message'>{errors.email?.message}</p>
                    </div>

                    <div>
                        <div className='input-container'>
                            <label> Company / Organization </label>
                            <input type='text' className='input' {...register('organization')} autoComplete="new-password" />
                        </div>
                        <p className='error-message'>{errors.organization?.message}</p>
                    </div>

                    <div>
                        <div className='input-container'>
                            <label> Password </label>
                            <input type={isShowPassword ? 'text' : 'password'} {...register('password')} className='input' autoComplete="new-password" />
                            <div className='icon'>
                                {isShowPassword ?
                                    <MdOutlineVisibilityOff size={22} color='#C3C6CF' onClick={() => setIsShowPassword(false)} /> :
                                    <MdOutlineVisibility size={22} color='#C3C6CF' onClick={() => setIsShowPassword(true)} />
                                }
                            </div>
                        </div>
                        <p className='error-message'>{errors.password?.message}</p>
                    </div>

                    <div>
                        <div className='color-white d-flex align-items-center gap-8'>
                            <div className='p-12 d-flex'>
                                <input type="checkbox" className="custom-checkbox" {...register('terms')} />
                            </div>
                            <span>I agree to the Terms of Service and Privacy Policy.</span>
                        </div>
                        <p className='error-message'>{errors.terms?.message}</p>
                    </div>

                    <button className='theme-sky-btn'>Sign Up!</button>

                    <p className='color-white fw-light text-center'>
                        Already have an account?{' '}
                        <span className='text-decoration-underline cursor-pointer' onClick={() => navigate('/login')}>
                            Log In
                        </span>
                    </p>
                </form>
            </div>
        </div>
    );
};

export default Signup;
